export default __webpack_public_path__ + "static/media/beta.e2c44f0d.svg";